import { registerIcon } from "@ui5/webcomponents-base/dist/asset-registries/Icons.js";

const name = "alert";
const pathData = "M501 374q5 10 7.5 19.5T512 412v5q0 31-23 47.5T439 481H74q-13 0-26-4.5T24.5 464t-17-20T1 417q-1-13 3-22.5t9-20.5L198 38q24-38 61-38t59 38zM257 127q-13 0-23.5 8T223 161q1 7 3 23 2 14 3.5 37t3.5 61q0 11 7.5 16t15.5 5q22 0 24-21l2-36 9-85q0-18-10.5-26t-23.5-8zm0 299q20 0 31.5-12t11.5-32q0-19-11.5-31T257 339t-31.5 12-11.5 31q0 20 11.5 32t31.5 12z";
const ltr = false;
const accData = null;
const collection = "SAP-icons";
const packageName = "@ui5/webcomponents-icons";

registerIcon(name, { pathData, ltr, collection, packageName });

export default "SAP-icons/alert";
export { pathData, ltr, accData };